import { defineStore } from 'pinia'
import { Env } from '@voghion/fe-util'
import { computed, ref } from 'vue'
import { EVENT_APP_HIDE, EVENT_APP_SHOW, EVENT_HYBRID_SERVER_READY, jsBridge } from '@voghion/native-api'

/**
 * 环境
 */
export const useEnvStore = defineStore('env', () => {
  const env = Env.getInstance()
  const navigationBarHeight = ref(env.isAndroid ? 49 : 44)
  const statusBarHeight = ref(0)
  const pagePaddingTop = computed(() => {
    return navigationBarHeight.value + statusBarHeight.value
  })
  const hybridServerReady = ref(false)
  const inAppTab = ref(false)
  /**
   * app 是否可见
   */
  const appVisible = ref(true)
  /**
   * 窗口是否可见
   */
  const windowVisible = ref(true)
  /**
   * im 配置是否可用
   */
  let closeTimer: NodeJS.Timeout | undefined
  jsBridge.addEventListener(EVENT_APP_SHOW, () => {
    appVisible.value = true
    if (closeTimer) {
      clearTimeout(closeTimer)
      closeTimer = undefined
    }
  })
  jsBridge.addEventListener(EVENT_APP_HIDE, () => {
    if (env.isAndroid) {
      // android 在选相册或拉起相机时也会触发 hide 时间，所以延迟一分钟再断开
      if (closeTimer) {
        clearTimeout(closeTimer)
      }
      closeTimer = setTimeout(() => {
        appVisible.value = false
      }, 60000)
    } else {
      appVisible.value = false
    }
  })
  document.addEventListener('visibilitychange', () => {
    windowVisible.value = document.visibilityState === 'visible'
  })
  jsBridge.addEventListener(EVENT_HYBRID_SERVER_READY, () => {
    hybridServerReady.value = true
  })
  return {
    navigationBarHeight,
    statusBarHeight,
    inAppTab,
    pagePaddingTop,
    appVisible,
    windowVisible
  }
})
